import { API_URL } from '../config/constants';

export const login = async (userName, passwd) => {
    try {
        const request = new Request(API_URL + "/webAppLogin", {
            method: 'POST',
            body: JSON.stringify({
                username: userName,
                password: passwd,
            }),
            headers: new Headers({
                'Content-Type': 'application/json'
            })
        });
        const response = await fetch(request);
        if (response.status === 500 || response.status === 400) throw response;
        if (response.status === 401 || response.status === 403) throw response;
        const json = await response.json();
        const data = JSON.stringify({
            userName: userName,
            passwd: passwd,
            loggedIn: true,
            name: json.name,
            roles: json.roles,
            terminal_id: json.id,
            municipality: json.municipality_id,
            office: json.office_id
        })
        sessionStorage.setItem('session', data);
    } catch (err) {
        if (!err.code && !err.status) err.status = 500;
        throw err;
    }
}



// WEBPACK FOOTER //
// ./src/controllers/login.js